import { useMutation } from 'react-query';

import { APIBaseChronos } from '@/api/hosts';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

export const useCreateThread = (matterId: string, subsetId: string) => {
  const { getFetchConfig } = useGetFetchConfig();

  const createThread = async (question: string) => {
    const fetchConfig = getFetchConfig({
      method: FetchMethod.POST,
      data: {
        question,
      },
    });

    const response = await fetch(`${APIBaseChronos}/api/matter/${matterId}/subset/${subsetId}/thread`, fetchConfig);
    if (!response.ok) {
      throw new Error('Creating thread failed');
    }
    return await response.json();
  };

  return useMutation(async (question: string) => await createThread(question));
};
